var map = {
	"./3x3basketball-dark.svg": "88e7",
	"./3x3basketball.svg": "ee6c",
	"./all-sports-dark.svg": "5b20",
	"./all-sports.svg": "8718",
	"./americanfootball-dark.svg": "a924",
	"./americanfootball.svg": "5a0e",
	"./aussie-rules-dark.svg": "e7de",
	"./aussie-rules.svg": "2125",
	"./australianrules-dark.svg": "efbf",
	"./australianrules.svg": "5d913",
	"./badminton-dark.svg": "a100",
	"./badminton.svg": "bbd6",
	"./baseball-dark.svg": "078a",
	"./baseball.svg": "4cd5",
	"./basketball-dark.svg": "63c5",
	"./basketball.svg": "b134",
	"./beachvolleyball-dark.svg": "cd62",
	"./beachvolleyball.svg": "51d2",
	"./bowls-dark.svg": "d6b5",
	"./bowls.svg": "1c67",
	"./boxing-dark.svg": "880f",
	"./boxing.svg": "94bb",
	"./chevron.svg": "2a09",
	"./cricket-dark.svg": "55c7",
	"./cricket.svg": "20bc",
	"./darts-dark.svg": "5d91",
	"./darts.svg": "6c4d",
	"./esports-dark.svg": "2249",
	"./esports.svg": "5311",
	"./football-dark.svg": "6c2e",
	"./football.svg": "ab74",
	"./formulaone-dark.svg": "ed7a",
	"./formulaone.svg": "840b",
	"./futsal-dark.svg": "7d84",
	"./futsal.svg": "e704",
	"./gaelicfootball-dark.svg": "e0a4",
	"./gaelicfootball.svg": "f139",
	"./handball-dark.svg": "3d9f",
	"./handball.svg": "2bb8",
	"./hockey-dark.svg": "9bf1",
	"./hockey.svg": "6ce6",
	"./horse-racing-dark.svg": "51e1",
	"./horse-racing.svg": "5a21",
	"./hurling-dark.svg": "d82b",
	"./hurling.svg": "6a3e",
	"./icehockey-dark.svg": "26eb",
	"./icehockey.svg": "4ce6",
	"./live-in-play-star.svg": "503f",
	"./mixedmartialarts-dark.svg": "fe39",
	"./mixedmartialarts.svg": "37c2",
	"./motorsport-dark.svg": "6a3c",
	"./motorsport.svg": "a0da",
	"./pickleball-dark.svg": "fc16",
	"./pickleball.svg": "363b",
	"./rugby-dark.svg": "6f68",
	"./rugby.svg": "2f63",
	"./rugbyleague-dark.svg": "cfe6",
	"./rugbyleague.svg": "b236",
	"./rugbyunion-dark.svg": "0f46",
	"./rugbyunion.svg": "bad1",
	"./snooker-dark.svg": "352a",
	"./snooker.svg": "d312",
	"./soccer-dark.svg": "f1c9",
	"./soccer.svg": "eb27",
	"./squash-dark.svg": "7bf0",
	"./squash.svg": "d446",
	"./streamingevents-dark.svg": "aef0",
	"./streamingevents.svg": "26a7",
	"./streamingtab-dark.svg": "a635",
	"./streamingtab.svg": "2fdbe",
	"./tabletennis-dark.svg": "f40f",
	"./tabletennis.svg": "1706",
	"./tennis-dark.svg": "403e",
	"./tennis.svg": "ee76",
	"./tennisdoubles-dark.svg": "a781",
	"./tennisdoubles.svg": "1f7b",
	"./testcricket-dark.svg": "6823",
	"./testcricket.svg": "80c6",
	"./volleyball-dark.svg": "6566",
	"./volleyball.svg": "be18",
	"./waterpolo-dark.svg": "da06",
	"./waterpolo.svg": "64bc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "909e";